// Performance Mode - Gestion centralisée de l'optimisation des requêtes
export const PerformanceMode = {
  isEnabled: () => localStorage.getItem('performance_mode') === 'true',
  
  enable: () => {
    localStorage.setItem('performance_mode', 'true');
    localStorage.setItem('system_auto_monitoring', 'false');
    localStorage.setItem('realtime_metrics_auto', 'false');
    localStorage.setItem('realtime_monitoring_enabled', 'false');
    console.log('🟢 Mode Économique ACTIVÉ - Polling désactivé');
    window.location.reload();
  },
  
  disable: () => {
    localStorage.setItem('performance_mode', 'false');
    localStorage.setItem('system_auto_monitoring', 'true');
    localStorage.setItem('realtime_metrics_auto', 'true');
    localStorage.setItem('realtime_monitoring_enabled', 'true');
    console.log('🔴 Mode Normal ACTIVÉ - Polling automatique activé');
    window.location.reload();
  },

  getStatus: () => {
    const isEnabled = PerformanceMode.isEnabled();
    
    return {
      enabled: isEnabled,
      systemMonitoring: localStorage.getItem('system_auto_monitoring') === 'true',
      realtimeMetrics: localStorage.getItem('realtime_metrics_auto') === 'true',
      realtimeMonitoring: localStorage.getItem('realtime_monitoring_enabled') === 'true',
      // ⚠️ ESTIMATION THÉORIQUE - Valeurs approximatives basées sur le comportement attendu
      estimatedDailyRequests: isEnabled ? '~40K (estimation)' : '~216K (estimation)',
      estimatedReduction: isEnabled ? '~81% (estimation)' : '0%',
      isEstimated: true // Flag pour indiquer que ce sont des estimations
    };
  }
};
